import React, { useEffect } from 'react';

import { Platform } from 'react-native';
import { BranchParams } from 'react-native-branch';

import useEffectOnce from 'hooks/use-effect-once';
import useBranch from 'state/branch/hooks/use-branch';
import { categorizeTraffic } from 'state/branch/utils/deep-links';
import { brand, isLocalDev } from 'utils/environment';

/**
 for miscellaneous platform specific components/hooks ONLY - if not platform specific put in ./generic-miscellaneous.tsx
 */
export const PlatformSpecificMiscellaneous: React.FC = React.memo(() => {
  const { initBranch } = useBranch();

  useEffect(() => {
    if (!isLocalDev) {
      const renderSuccessTime = performance.now?.();
      const durationTillRenderSuccess = renderSuccessTime - LOADING_START_TIME;
      (window.dataLayer || []).push({
        event: 'APP_REACT_RENDER_SUCCESS',
        brand: brand(),
        timestamp: renderSuccessTime,
        duration: durationTillRenderSuccess,
        platform: Platform.OS,
      });
    }
  }, []);

  useEffectOnce(() => {
    if (window && !window.branch) {
      initBranch();
    }
  });

  useEffectOnce(() => {
    categorizeTraffic({} as BranchParams);
  });

  return null;
});

// Create start time before trying to render the app for true performance numbers
const LOADING_START_TIME = performance.now?.() ?? 0;
